import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lean-postit',
  templateUrl: './lean-postit.component.html',
  styleUrls: ['./lean-postit.component.scss']
})

export class LeanPostitComponent implements OnInit {


  @Input() title          : string = "Kpi"; 
  @Input() color          : string = "darkorange"

  @Input() width          : string = '200';
  @Input() minWidth       : string = '200';
 

  constructor() {
  }


  ngOnInit() {

  }



}
